import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RiesgoService } from 'src/app/service/riesgo/riesgo.service';

@Component({
  selector: 'app-respuesta-no-precalifica',
  templateUrl: './respuesta-no-precalifica.component.html',
  styleUrls: ['./respuesta-no-precalifica.component.scss']
})

export class RespuestaNoPrecalificaComponent implements OnInit {
  titulo: string = "Evalúa tu factura";
  rucAdq: any;
  ranking: any;
  mensaje: any;
  viewMessage:boolean = false;
  loadingPrincipal:boolean = false;
  nombreCompleto:string;
  nombre:string;

  constructor(private riesgosService: RiesgoService, private route: ActivatedRoute, private router: Router) { }

  ngOnInit() {
    this.route.params.subscribe(
      res => {
        this.rucAdq = res['rucAdq'];
        if (this.rucAdq == null || this.rucAdq == "") {
          this.router.navigate(['evalua-tu-factura']);
        } else {
          console.log("Res rucAqd: ", this.rucAdq);
          this.obtenerRanking();
        }
      },
      err => {
        console.log("Error :", err);
      }
    );
    this.nombreCompleto = localStorage.getItem("Nombre");
    this.nombre = this.nombreCompleto.split(' ')[0]
  }

  obtenerRanking() {
    this.loadingPrincipal = true;
    /* OBTENER RANKING AL ENTRAR EN LA PÁGINA, USANDO COMO PARAM EL rucAdq DE LA RUTA */
    this.riesgosService.obtenerRanking(this.rucAdq).subscribe(
      res => {
        this.loadingPrincipal = false;
        console.log("Res desde obtener ranking: ", res);
        this.ranking = res;
        if (this.ranking > 6000) {
          this.viewMessage = true;
          this.mensaje = `¡Hola! ${this.nombre} tu cliente ${this.rucAdq} no pre-califica para la venta de tu factura`;
        }
        //  else {
        //   this.router.navigate(["evalua-tu-factura"]);
        // }
      },
      err => {
        this.loadingPrincipal = false;
        this.viewMessage = true;
      }
    );
  }
}
